export default "__VITE_ASSET__Xc_FKW9s__"